<template>
  <div>
    <a-form :form="form" @submit="handleSubmit" :initialValue="user">
      <a-form-item label="姓名" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-input
          v-decorator="['name', {
                  rules: [{ required: true, message: '请输入姓名' }],
                  initialValue:user.name
                }]"
        />
      </a-form-item>
      <a-form-item label="用户名" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-input
          v-decorator="['username', {
                  rules: [{ required: true, message: '请输入用户名' }],
                  initialValue:user.username
                }]"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item label="邮箱" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-input
          v-decorator="['email', {
                  rules: [{ required: true, message: '请输入邮箱' }],
                  initialValue:user.email
                }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="手机" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-input
          v-decorator="['mobile', {
                  rules: [{ required: true, message: '请输入手机号' }],
                  initialValue:user.mobile
                }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="公司名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-input
          v-decorator="['company', {
                  rules: [{ required: true, message: '请输入公司名称' }],
                  initialValue:user.company
                }]"
        ></a-input>
      </a-form-item>
    </a-form>
    <div
      :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
    >
      <a-button :style="{marginRight: '8px'}" @click="reset">重置</a-button>
      <a-button type="primary">提交</a-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  created() {
    // eslint-disable-next-line
    console.log(this.user);
  },
  methods: {
    reset() {
      this.form.resetFields();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // eslint-disable-next-line
          console.log("Received values of form: ", values);
        }
      });
    }
  }
};
</script>
<style>
</style>